import styled from 'styled-components';
import { Group, Shelf, Badge, palette } from '@landr/maestro';
import { Link } from 'react-router-dom';

export const AbsoluteContainer = styled.div`
    position: absolute;
    width: 100%;
    max-width: 192px;
    height: 100%;
    bottom: 0;
    border-radius: 4px;
    overflow: hidden;
`;

export const Center = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;
`;

export const CardContainer = styled(Group.Item)`
    cursor: pointer;
    margin-right: 25px;
    border-radius: 4px;
    overflow: hidden;
`;

export const PackCardSquareSize = 192;

export const BgImage = styled.div`
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px;
    margin-bottom: ${({ theme }) => theme.spacing('md')};
    position: relative;

    &:before {
        content: ' ';
        display: block;
        padding-bottom: 100%;
        position: relative;
    }

    > img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        max-width: 100%;
    }
`;

export const FallbackWrapper = styled.div`
    align-items: center;
    background-color: ${({ theme }) => theme.palette.neutral[800]};
    color: ${({ theme }) => theme.colors.text.base};
    display: flex;
    justify-content: center;

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    svg {
        opacity: 0.64;
        height: 65%;
        width: 65%;
        stroke-width: 0.25;

        g {
            stroke-width: 0.25;
        }
    }
`;

export const BottomContainer = styled(Shelf.Bottom)`
    display: flex;
    justify-content: space-between;
`;

export const LinkWrapper = styled(Link)`
    color: inherit;
    text-decoration: none;
    height: 100%;
    position: relative;
`;

export const FavoriteButtonWrapper = styled.div`
    width: 24px;
    height: 24px;
    > button {
        width: 24px;
        height: 24px;
    }
`;

export const StyledBadge = styled(Badge)`
    background-color: ${palette('neutral.1000', 0.36)};
    color: ${palette('neutral.50')};
`;
